import { GET_DELIVERY_AGGREGATOR, GET_DELIVERY_AGGREGATOR_SUCCESS, GET_DELIVERY_AGGREGATOR_ERROR, } from '../../constants';
const initialState = {
    response: {},
    error: false,
    isLoading: false,
};
/**
 * deliveryAggregatorReducer
 * @param state {object} initial and final state of data
 * @param action {object} action object containing type of action provided
 * @return {{isLoading: boolean, response: {}, error: boolean}|{isLoading: boolean, response, error: boolean}|{isLoading: boolean, response: {}, error: boolean}}
 */
const deliveryAggregatorReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DELIVERY_AGGREGATOR:
            return {
                ...state,
                isLoading: true,
            };
        case GET_DELIVERY_AGGREGATOR_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isLoading: false,
            };
        case GET_DELIVERY_AGGREGATOR_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
            };
        default:
            return state;
    }
};
export default deliveryAggregatorReducer;
